module.exports = __webpack_public_path__ + "static/fonts/ElegantIcons.f9d179f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/elegant_font/fonts/ElegantIcons.ttf
// module id = IlDp
// module chunks = 20